import React from 'react';
import '../styles/custom-button.scss'


const CustomButton = () => (

    <button className='custom-button button-default-outline' >
        Read More
    </button>
)


export default CustomButton